async function buyNow(product_id, stock_qty) {
  /**
  @description: 
  @param {} 
  **/

  if (document.querySelectorAll("#qty-" + product_id).length === 3) {
    let inputTag =null
    let qty = null
    for (let htmlInputTag of document.querySelectorAll("#qty-" + product_id)) {
      inputTag = htmlInputTag; 
      qty = parseInt(inputTag.value);
      if (!isNaN(qty)) {
        if (qty > stock_qty){
   swal({
      title: 'Insufficient Stock Quantity',
      text: "Only " + stock_qty + " are left in stock.",
      icon: "error",
      buttons: {
        cancel: {
        text: "Ok",
        value: null,
        visible: true,
        className: "swal-btn-cancel swal-btn-inline swal-btn-row1",
        closeModal: true,
        },
        rfq: {
        text: "Request a Quote",
        value: "rfq",
        visible: true,
        className: "swal-btn-confirm swal-btn-inline swal-btn-row1",
        closeModal: true,
        },
        checkout: {
        text: "Continue to checkout with " + stock_qty,
        value: "checkout",
        visible: true,
        className: "swal-btn-confirm swal-btn-block swal-btn-row2",
        closeModal: true,
        }
      }
      }).then(async (value) => {
      if (value === "checkout") {
        try {
        let response = await jQuery.post('/cart/add.js', {
          items: [{
          id: product_id,
          quantity: stock_qty,
          }]
        }, null, "json");
        if (response['statusCode'] == "error") {
          swal('Error\n', "We were unable to add this item to cart.", "error");
        } else {
          window.location.href = "/checkout";
        }
        } catch (e) {
        window.location.href = "/checkout";
        }
      } else if (value === "rfq") {
        window.location.href = '/pages/contact?rfq=' + encodeURIComponent(product_id);
      }
      });

      // Add custom CSS to arrange buttons in two rows
      setTimeout(() => {
      const swalFooter = document.querySelector('.swal-footer');
      if (swalFooter) {
        // Group row1 buttons
        const row1 = document.createElement('div');
        row1.style.display = 'flex';
        row1.style.justifyContent = 'center';
        row1.style.flexDirection = 'row-reverse';
        row1.style.gap = '8px';
        row1.className = 'swal-btn-row1-group';

        // Group row2 button
        const row2 = document.createElement('div');
        row2.style.marginTop = '12px';
        row2.style.display = 'flex';
        row2.style.justifyContent = 'center';
        row2.className = 'swal-btn-row2-group';

        swalFooter.style.display = 'flex';
        swalFooter.style.flexDirection = 'column-reverse';
        swalFooter.style.alignItems = 'center';
        swalFooter.style.justifyContent = 'center';

        // Move buttons into rows
        const btnContainers = swalFooter.querySelectorAll('.swal-button-container');
        btnContainers.forEach(container => {
        const btn = container.querySelector('button');
        if (btn && btn.classList.contains('swal-btn-row1')) {
          row1.appendChild(container);
        } else if (btn && btn.classList.contains('swal-btn-row2')) {
          row2.appendChild(container);
        }
        });

        // Clear footer and append rows
        swalFooter.innerHTML = '';
        swalFooter.appendChild(row1);
        swalFooter.appendChild(row2);
      }
      }, 10);

            return;
        }
        try {
          let response = await jQuery.post('/cart/add.js', {
            items : [{
              id: product_id,
              quantity: qty,
            }]
          }, null,  "json");
          if (response['statusCode'] == "error"){
            swal('Error\n',"We were unable to add this item to cart.", "error");
          } else {
            window.location.href="/checkout";
          }
        } catch(e) {
          window.location.href="/checkout";
          swal.fire(
            'Error\n',"An unknown error has occured.", "error"
          );
        }
      }
    }
  } 
  else {
    let inputTag = htmlEl("#qty-" + product_id)
    let qty = parseInt(inputTag.value);

    if (qty > stock_qty) {
      swal({
      title: 'Insufficient Stock Quantity',
      text: "Only " + stock_qty + " are left in stock.",
      icon: "error",
      buttons: {
        cancel: {
        text: "Ok",
        value: null,
        visible: true,
        className: "swal-btn-cancel swal-btn-inline swal-btn-row1",
        closeModal: true,
        },
        rfq: {
        text: "Request a Quote",
        value: "rfq",
        visible: true,
        className: "swal-btn-confirm swal-btn-inline swal-btn-row1",
        closeModal: true,
        },
        checkout: {
        text: "Continue to checkout with " + stock_qty,
        value: "checkout",
        visible: true,
        className: "swal-btn-confirm swal-btn-block swal-btn-row2",
        closeModal: true,
        }
      }
      }).then(async (value) => {
      if (value === "checkout") {
        try {
        let response = await jQuery.post('/cart/add.js', {
          items: [{
          id: product_id,
          quantity: stock_qty,
          }]
        }, null, "json");
        if (response['statusCode'] == "error") {
          swal('Error\n', "We were unable to add this item to cart.", "error");
        } else {
          window.location.href = "/checkout";
        }
        } catch (e) {
        window.location.href = "/checkout";
        }
      } else if (value === "rfq") {
        window.location.href = '/pages/contact?rfq=' + encodeURIComponent(product_id);
      }
      });

      // Add custom CSS to arrange buttons in two rows
      setTimeout(() => {
      const swalFooter = document.querySelector('.swal-footer');
      if (swalFooter) {
        // Group row1 buttons
        const row1 = document.createElement('div');
        row1.style.display = 'flex';
        row1.style.justifyContent = 'center';
        row1.style.flexDirection = 'row-reverse';
        row1.style.gap = '8px';
        row1.className = 'swal-btn-row1-group';

        // Group row2 button
        const row2 = document.createElement('div');
        row2.style.marginTop = '12px';
        row2.style.display = 'flex';
        row2.style.justifyContent = 'center';
        row2.className = 'swal-btn-row2-group';

        swalFooter.style.display = 'flex';
        swalFooter.style.flexDirection = 'column-reverse';
        swalFooter.style.alignItems = 'center';
        swalFooter.style.justifyContent = 'center';

        // Move buttons into rows
        const btnContainers = swalFooter.querySelectorAll('.swal-button-container');
        btnContainers.forEach(container => {
        const btn = container.querySelector('button');
        if (btn && btn.classList.contains('swal-btn-row1')) {
          row1.appendChild(container);
        } else if (btn && btn.classList.contains('swal-btn-row2')) {
          row2.appendChild(container);
        }
        });

        // Clear footer and append rows
        swalFooter.innerHTML = '';
        swalFooter.appendChild(row1);
        swalFooter.appendChild(row2);
      }
      }, 10);

      return;
    
    }
    try {
      let response = await jQuery.post('/cart/add.js', {
        items : [{
          id: product_id,
          quantity: qty,
        }]
      }, null,  "json");
      if (response['statusCode'] == "error"){
        swal('Error\n',"We were unable to add this item to cart.", "error");
      } else {
        window.location.href="/checkout";
      }
    } catch(e) {
      window.location.href="/checkout";
    }
  }
}
async function buyNowDrac(product_id, stock_qty, serial) {
  /**
  @description: 
  @param {} 
  **/
  if (serial === "") {
    buyNow(product_id, stock_qty);
  }
  if (serial === "noSerial") return;
  if (document.querySelectorAll("#qty-" + product_id).length === 3) {
    let inputTag =null
    let qty = null

    for (let htmlInputTag of document.querySelectorAll("#qty-" + product_id)) {
      inputTag = htmlInputTag; 
      qty = parseInt(inputTag.value);
      if (!isNaN(qty)) {
        if (qty > stock_qty){
          swal('Insufficient Stock Quantity\n',"Only "+stock_qty+" are left in stock.", "error");
          return;
        }
        try {
          let response = await jQuery.post('/cart/add.js', {
            items : [{
              id: product_id,
              quantity: qty,
              properties: {"Server Serial": serial}
            }]
          }, null,  "json");
          if (response['statusCode'] == "error"){
            swal('Error\n',"We were unable to add this item to cart.", "error");
          } else {
            window.location.href="/checkout";
          }
        } catch(e) {
          swal('Error\n',"An unknown error has occured.", "error");
        }
      }
    }
  } else {
    let inputTag = htmlEl("#qty-" + product_id)
    let qty = parseInt(inputTag.value);

    if (qty > stock_qty){
      swal('Insufficient Stock Quantity\n',"Only "+stock_qty+" are left in stock.", "error");
      return;
    }
    try {
      let response = await jQuery.post('/cart/add.js', {
        items : [{
          id: product_id,
          quantity: qty,
          properties: {"Server Serial": serial}
        }]
      }, null,  "json");
      if (response['statusCode'] == "error"){
        swal('Error\n',"We were unable to add this item to cart.", "error");
      } else {
        window.location.href="/checkout";
      }
    } catch(e) {
      console.log(e)
      swal('Error\n',"An unknown error has occured.", "error");
    }
  }
}